import Vue from 'vue'
import { CollapseTransition } from 'vue2-transitions'

// Utility to localise address forms specific to Shopify.
// https://github.com/Shopify/theme-scripts/blob/master/packages/theme-addresses/README.md
import { AddressForm } from '@shopify/theme-addresses'

export default {
  components: {
    CollapseTransition
  },

  data () {
    return {
      isNewAddressFormShown: false,
      addressToggles: [],
      isSelectLoaded: false
    }
  },

  mounted () {
    AddressForm(this.$refs.newAddress, 'en')

    if (this.$refs.addressCount) {
      for (let i = 0; i < parseInt(this.$refs.addressCount.value); i++) {
        AddressForm(this.$refs[`address${i}`], 'en')
        Vue.set(this.addressToggles, i, false)
      }
    }

    document.addEventListener('click', this.closeAllSelect)
  },

  methods: {
    toggleNewAddressForm () {
      this.isNewAddressFormShown = !this.isNewAddressFormShown

      if (!this.isSelectLoaded) {
        const vm = this
        setTimeout(function () { vm.selectScript() }, 1000)
        this.isSelectLoaded = !this.isSelectLoaded
      }
    },

    toggleAddressForm (index) {
      Vue.set(this.addressToggles, index, !this.addressToggles[index])

      if (!this.isSelectLoaded) {
        const vm = this
        setTimeout(function () { vm.selectScript() }, 1000)
        this.isSelectLoaded = !this.isSelectLoaded
      }
    },

    deleteAddress (event) {
      const confirmMessage = event.target.getAttribute('data-confirm-message')

      if (!window.confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        event.preventDefault()
      }
    },

    selectScript () {
      const vm = this // Store the Vue instance context
      const changeCountryBound = this.changeCountry.bind(vm)
      let i, j, selectElement, selectedItemDiv, optionList, optionItem
      const selectContainer = document.getElementsByClassName('floating-input')

      for (i = 0; i < selectContainer.length; i++) {
        selectElement = selectContainer[i].querySelector('select')

        if (selectElement) {
          selectedItemDiv = document.createElement('DIV')
          selectedItemDiv.setAttribute('class', 'select-selected')
          selectedItemDiv.innerHTML = selectElement.options[selectElement.selectedIndex].innerHTML
          selectContainer[i].appendChild(selectedItemDiv)
          /* For each element, create a new DIV that will contain the option list: */
          optionList = document.createElement('DIV')
          optionList.setAttribute('class', 'select-items select-hide')

          for (j = 1; j < selectElement.length; j++) {
            optionItem = document.createElement('DIV')
            optionItem.innerHTML = selectElement.options[j].innerHTML

            optionItem.addEventListener('click', function (e) {
              let y, i, k, yl
              const s = this.parentNode.parentNode.getElementsByTagName('select')[0]
              const sl = s.length
              const h = this.parentNode.previousSibling
              const selectChangeEvent = new Event('change')

              for (i = 0; i < sl; i++) {
                if (s.options[i].innerHTML === this.innerHTML) {
                  s.selectedIndex = i
                  h.innerHTML = this.innerHTML
                  y = this.parentNode.getElementsByClassName('same-as-selected')
                  yl = y.length
                  s.dispatchEvent(selectChangeEvent)

                  for (k = 0; k < yl; k++) {
                    y[k].removeAttribute('class')
                  }
                  this.setAttribute('class', 'same-as-selected')

                  if (s.name === 'address[country]') {
                    const event = { target: { value: s.value, form_id: s.getAttribute('data-form-id') } }
                    changeCountryBound(event)
                  }

                  break
                }
              }

              h.click()
            })

            optionList.appendChild(optionItem)
          }

          selectContainer[i].appendChild(optionList)

          selectedItemDiv.addEventListener('click', function (event) {
            /* When the select box is clicked, close any other select boxes, and open/close the current select box: */
            event.stopPropagation()
            // this.this.closeAllSelect(this)
            const arrNo = []
            const selectedItems = document.getElementsByClassName('select-items')
            const selectedItem = document.getElementsByClassName('select-selected')
            let i

            for (i = 0; i < selectedItem.length; i++) {
              if (this === selectedItem[i]) {
                arrNo.push(i)
              } else {
                selectedItem[i].classList.remove('select-arrow-active')
              }
            }

            for (i = 0; i < selectedItems.length; i++) {
              if (arrNo.indexOf(i)) {
                selectedItems[i].classList.add('select-hide')
              }
            }

            this.nextSibling.classList.toggle('select-hide')
            this.classList.toggle('select-arrow-active')
          })
        }
      }
    },

    changeCountry (event) {
      const provinceField = document.getElementById('AddressProvince_' + event.target.form_id)
      const stateSelectContainer = provinceField.parentElement.querySelector('.select-items')
      const selectSelected = provinceField.parentElement.querySelector('.select-selected')
      const selectChangeEvent = new Event('change')

      stateSelectContainer.innerHTML = ''

      if (provinceField.parentElement.getAttribute('data-aria-hidden') === 'false') {
        // Get the options of the <select> element
        provinceField.selectedIndex = 0
        selectSelected.innerHTML = provinceField.options[0].textContent
        const options = provinceField.options

        // Iterate over the options and log their values and text content
        for (let i = 0; i < options.length; i++) {
          const stateOption = document.createElement('div')
          stateOption.textContent = options[i].textContent

          stateOption.addEventListener('click', (e) => {
            const elements = provinceField.parentElement.querySelectorAll('.select-items > div')

            elements.forEach(element => {
              element.removeAttribute('class')
            })

            provinceField.selectedIndex = i
            selectSelected.innerHTML = provinceField.options[i].textContent
            e.target.classList.add('same-as-selected')
            stateSelectContainer.classList.toggle('select-hide')
            provinceField.dispatchEvent(selectChangeEvent)
          })

          stateSelectContainer.appendChild(stateOption)
        }
      }
    },

    closeAllSelect (element) {
      /* A function that will close all select boxes in the document,
      except the current select box: */
      const arrNo = []
      const selectedItems = document.getElementsByClassName('select-items')
      const selectedItem = document.getElementsByClassName('select-selected')
      let i

      for (i = 0; i < selectedItem.length; i++) {
        if (element === selectedItem[i]) {
          arrNo.push(i)
        } else {
          selectedItem[i].classList.remove('select-arrow-active')
        }
      }
      for (i = 0; i < selectedItems.length; i++) {
        if (arrNo.indexOf(i)) {
          selectedItems[i].classList.add('select-hide')
        }
      }
    }
  }
}
